import { render } from "./RelProdutosPorData.vue?vue&type=template&id=094c8d70"
import script from "./RelProdutosPorData.vue?vue&type=script&lang=js"
export * from "./RelProdutosPorData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__